export enum OrdersTableMode {
  UNKNOWN,
  BASE,
  DEALT,
  NDF_BASE,
  NDF_DEALT,
}

export namespace OrdersTableMode {
  let elements = [
    OrdersTableMode.UNKNOWN,
    OrdersTableMode.BASE,
    OrdersTableMode.DEALT,
    OrdersTableMode.NDF_BASE,
    OrdersTableMode.NDF_DEALT,
  ];

  export function getAllElements() {
    return elements;
  }

  export function isDealt(mode: OrdersTableMode): boolean {
    return OrdersTableMode.DEALT === mode || OrdersTableMode.NDF_DEALT === mode;
  }

  export function isBase(mode: OrdersTableMode): boolean {
    return OrdersTableMode.BASE === mode || OrdersTableMode.NDF_BASE === mode;
  }

  export function isNdf(mode: OrdersTableMode): boolean {
    return OrdersTableMode.NDF_BASE === mode || OrdersTableMode.NDF_DEALT === mode;
  }

  export function isSpot(mode: OrdersTableMode): boolean {
    return OrdersTableMode.BASE === mode || OrdersTableMode.DEALT === mode;
  }
}
